<template>
  <div class="search-follow">
    <el-row class="select-input" v-if="isSelected === false">
      <el-col :span="9">
        <el-autocomplete style="width: 100%;" popper-class="base-info-autocomplete" v-model.trim="form.patientName"
          :fetch-suggestions="loadPatientList" placeholder="姓名" hide-loading :maxlength="50" size="mini"
          :style="`height: ${height}px;`" @select="handleSelect">
          <template slot-scope="{ item }">
            <div class="search-member-info-list-wrap">
              <div class="search-member-name">
                <svg-icon class-name="record-icon" icon-class="medical-record" />
                <span class="record-member-name" v-if="item.patientName">{{ item.patientName }}</span>
                <span class="record-member-name-empty" v-else>未设置</span>
                <span class="record-member-sex">{{ formatGender(item.patientGender) }}</span>
                <span class="record-member-age">{{ item.patientAge }}岁</span>
              </div>
              <div class="search-member-other">
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">就诊卡号：</span>
                  <span class="search-member-item-value">{{ item.medicalCardNumber }}</span>
                </div>
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">身份证：</span>
                  <span class="search-member-item-value">{{ item.idNumber }}</span>
                </div>
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">手机号：</span>
                  <span class="search-member-item-value">{{ item.patientPhone }}</span>
                </div>
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">就诊时间：</span>
                  <span class="search-member-item-value">{{ item.lastTreatTime }}</span>
                </div>
              </div>
            </div>
          </template>
          <i class="el-icon-user el-input__icon" slot="prepend">
          </i>
        </el-autocomplete>
      </el-col>
      <el-col :span="9">
        <el-autocomplete style="width: 100%;" :style="`height: ${height}px;`" popper-class="base-info-autocomplete"
          v-model="form.patientPhone" :fetch-suggestions="loadPatientList" placeholder="手机号" hide-loading size="mini"
          @select="handleSelect">
          <template slot-scope="{ item }">
            <div class="search-member-info-list-wrap">
              <div class="search-member-name">
                <svg-icon class-name="record-icon" icon-class="medical-record" />
                <span class="record-member-name" v-if="item.patientName">{{ item.patientName }}</span>
                <span class="record-member-name-empty" v-else>未设置</span>
                <span class="record-member-sex">{{ formatGender(item.patientGender) }}</span>
                <span class="record-member-age">{{ item.patientAge }}岁</span>
              </div>
              <div class="search-member-other">
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">就诊卡号：</span>
                  <span class="search-member-item-value">{{ item.medicalCardNumber }}</span>
                </div>
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">身份证：</span>
                  <span class="search-member-item-value">{{ item.idNumber }}</span>
                </div>
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">手机号：</span>
                  <span class="search-member-item-value">{{ item.patientPhone }}</span>
                </div>
                <div class="search-member-item-wrap">
                  <span class="search-member-item-title">就诊时间：</span>
                  <span class="search-member-item-value">{{ item.lastTreatTime }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-autocomplete>
      </el-col>
      <el-col :span="4">
        <el-select :style="`height: ${height}px;`" placeholder="性别" v-model="form.patientGender" size="mini">
          <el-option :value="1" label="男" />
          <el-option :value="2" label="女" />
        </el-select>
      </el-col>
      <el-col :span="2" :style="`height: ${height}px;`"
        style="display: flex;justify-content: center;align-items: center;">
        <el-tooltip content="新增患者" placement="top">
          <img class="icon" v-if="form.patientName || form.patientGender || form.patientAge || form.patientPhone"
            src="~@/assets/images/user-add.png" alt="" @click="editPatient" />
        </el-tooltip>
      </el-col>
    </el-row>
    <div class="input" v-if="isSelected === true">
      <el-input :style="`height: ${height}px;`" placeholder="请输入内容" v-model="currentPatientText" readonly
        @clear="clearSelect">
        <template slot="prepend">{{ inputPrepend }}</template>
      </el-input>
      <i class="el-icon-circle-close clear" @click="clearSelect"></i>
    </div>
    <add-patient-dialog ref="editDialogRef" @refresh="refreshListData" @selectNew="handleSelect" />
  </div>
</template>

<script>
import AddPatientDialog from '@/views/doctor2/manage/patient/components/base/add-patient-dialog.vue'
import { getPatientList } from '@/api/business/doctor/follow'

export default {
  name: 'SelectAddPatient',
  components: { AddPatientDialog },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: Number,
      default: () => 40
    },
    inputPrepend: {
      type: String,
      default: () => '随访患者'
    },
    remoteMethod: {
      type: Promise,
      default: () => getPatientList
    },
    selectedState: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      queryLoading: false,
      isSelected: this.selectedState,
      form: {
        patientCode: '',
        patientName: '',
        height: 0,
        idNumber: '',
        medicalCardNumber: '',
        patientAge: 0,
        patientBirthday: '',
        patientGender: 1,
        patientPhone: '',
        userAddress: '',
        weight: 0
      }
    }
  },
  computed: {
    currentPatientText() {
      if (this.isSelected === true) {
        let text = (this.form.patientName ? this.form.patientName : '') +
          '   ' + this.formatGender(this.form.patientGender) +
          this.formatPatientAge(this.form) +
          '   ' + (this.form.patientPhone ? this.form.patientPhone : '')
        return text
      } else {
        return ''
      }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length >= 1) {
          this.form = newVal
          this.isSelected = true
          this.$emit('update:selectedState', true)
        } else {
          this.form = {
            patientCode: '',
            patientName: '',
            height: 0,
            idNumber: '',
            medicalCardNumber: '',
            patientAge: 0,
            patientBirthday: '',
            patientGender: 1,
            patientPhone: '',
            userAddress: '',
            weight: 0
          }
          this.isSelected = false
          this.$emit('update:selectedState', false)
        }
      },
      immediate: true // 立即执行一次
    },
    selectedState(newVal) {
      this.isSelected = newVal
    }
  },
  methods: {
    // 获取性别
    formatGender(gender) {
      if (gender === 1) {
        return '男'
      } else if (gender === 2) {
        return '女'
      } else {
        return '未知'
      }
    },
    // 默认加载全部患者
    getPatientList,
    // 加载需要创建随访的患者列表
    loadPatientList(queryString, cb) {
      if (!queryString || queryString.trim().length < 1) {
        // eslint-disable-next-line standard/no-callback-literal
        cb([])
        return
      }
      this.queryLoading = true
      const params = {
        patientName: this.form.patientName,
        patientPhone: this.form.patientPhone
      }
      this.remoteMethod(params).then(({ data }) => {
        if (data && data.code === 0) {
          this.patientOptions = data.data
          cb(this.patientOptions)
        } else {
          // eslint-disable-next-line standard/no-callback-literal
          cb([])
        }
      }).finally(() => {
        this.queryLoading = false
      })
    },
    // 处理选择，如果添加新患者，则创建完成后自动选择新患者
    handleSelect(item) {
      this.isSelected = true
      this.$emit('update:selectedState', true)
      this.form = { ...item }
      this.$emit('input', this.form)
    },
    clearSelect() {
      this.isSelected = false
      this.form = {
        patientCode: '',
        patientName: '',
        height: 0,
        idNumber: '',
        medicalCardNumber: '',
        patientAge: 0,
        patientBirthday: '',
        patientGender: 1,
        patientPhone: '',
        userAddress: '',
        weight: 0
      }
      this.$emit('input', {})
      this.$emit('update:selectedState', false)
      this.$emit('clearSelected')
    },
    // 打开修改患者页面
    editPatient() {
      this.$refs.editDialogRef.open(this.form)
    },
    // 默认使用refresh来对父组件患者列表进行刷新
    refreshListData() {
      this.$emit('refresh')
    },
    calculateAgeByBirthday(birth) {
      const birthYear = parseInt(birth.substring(0, 4))
      const birthMonth = parseInt(birth.substring(5, 7))
      const birthDay = parseInt(birth.substring(8, 10))

      const today = new Date()
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth() + 1
      const currentDay = today.getDate()

      let age = currentYear - birthYear

      if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
        age-- // 还未过生日，年龄减一
      }
      return age
    },
    // 判断患者年龄
    formatPatientAge(row) {
      if ((!row.patientAge || row.patientAge <= 0) && !row.patientBirthday) {
        return ''
      } else if (row.patientBirthday) {
        const tempAge = this.calculateAgeByBirthday(row.patientBirthday)
        return tempAge > 0 ? '   ' + row.patientAge + '岁' : row.patientAge && row.patientAge > 0 ? '   ' + row.patientAge + '岁' : ''
      } else if (row.patientAge && row.patientAge > 0) {
        return '   ' + row.patientAge + '岁'
      }
    }
  }
}
</script>

<style lang="scss">
.base-info-autocomplete {

  .el-autocomplete-suggestion__list {
    padding: 8px 0;

    li {
      padding: 10px;

      &+li {
        border-top: 1px dashed #dee0e3;
      }
    }
  }

  .el-autocomplete-suggestion__wrap {
    padding: 0;
  }

  .search-member-info-list-wrap {
    padding: 0 10px;
    box-sizing: border-box;

    .search-member-name {
      display: flex;
      align-items: center;
      position: relative;

      .record-icon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }

      .record-member-name,
      .record-member-sex,
      .record-member-age {
        font-size: 16px;
        line-height: 20px !important;
        font-weight: bold;
        color: #606266;
      }

      .record-member-name-empty {
        font-size: 16px;
        font-style: italic;
        margin-right: 6px;
        color: #606266;
      }

      .record-member-sex {
        margin-left: 10px;
      }

      .record-member-age {
        margin-left: 10px;
      }
    }

    .search-member-other {
      padding-top: 4px;

      .search-member-item-wrap {
        margin-top: 4px;
        line-height: 20px !important;
      }

      .search-member-item-title {
        line-height: 20px !important;
        font-size: 14px;
        color: #C0C4CC;
      }

      .search-member-item-value {
        line-height: 20px !important;
        font-size: 14px;
        color: #606266;
      }
    }
  }
}

.el-autocomplete-suggestion.el-popper.base-info-autocomplete {
  width: 300px !important;
}
</style>
<style scoped lang="scss">
.search-follow {
  display: flex;
  justify-content: space-between;
  margin: 10px 10px 10px 0;

  .select-input {
    display: flex;
    align-items: center;
    border: 1px solid rgba(63, 122, 255, 0.349);
    border-radius: 10px;
    width: 100%;
    position: relative;

    /deep/ .el-input {
      height: 100%;

      &:focus,
      &:hover {
        border: 1px solid var(--theme-color) !important;
        border-radius: 5px;
        box-shadow: 0 0 0 2px rgba(63, 122, 255, 0.2);
      }
    }

    /deep/ .el-input__inner {
      height: 100%;
      width: 100%;
      background: rgba(244, 248, 255, 0.39);
      border: 0;
      border-radius: 0;
      font-size: 18px;
      padding-right: 0;
    }

    /deep/ .el-input-group__prepend {
      border: 0;
      font-size: 18px;
      padding: 0 15px;
      background: rgba(244, 248, 255, 0.39);
    }

    .icon {
      border: 0;
      width: 25px;
      height: 25px;
      cursor: pointer;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .input {
    display: flex;
    border: 1px solid rgba(63, 122, 255, 0.349);
    border-radius: 10px;
    width: 100%;

    .clear {
      margin: auto 0;
      margin-left: -20px;
      cursor: pointer;
      z-index: 1000;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }

    /deep/ .el-input {
      height: 100%;
    }

    /deep/ .el-input__inner {
      height: 100%;
      width: 100%;
      background: rgba(244, 248, 255, 0.39);
      border: 0;
      font-size: 18px;
      padding-right: 0;
    }

    /deep/ .el-input-group__prepend {
      border: 0;
      border-right: 1px solid rgba(63, 122, 255, 0.349);
      font-size: 18px;
      background: rgba(244, 248, 255, 0.39);
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/selectAddPatient/index.vue